// NOTE: Do not export these injection keys from the package
export const UNIQUE_ID_INJECTION_KEY = Symbol('The unique id that prefixes all identifiers within a single instance of the component')
export const TEXTAREA_ID_INJECTION_KEY = Symbol('Textarea unique id')
export const MODE_INJECTION_KEY = Symbol('Markdown component mode')
export const EDITABLE_INJECTION_KEY = Symbol('Is the markdown component editable')
export const FULLSCREEN_INJECTION_KEY = Symbol('Is the markdown component displaying fullscreen')
export const THEME_INJECTION_KEY = Symbol('Active theme, light or dark')
export const HTML_PREVIEW_INJECTION_KEY = Symbol('Is the html preview enabled')
